import React from 'react';

import * as GlamstarChallengeTerms from 'components/markdown/GlamstarChallengeTerms.md';
import styles from './styles.module.scss';

export function TermsAndConditionsModal() {
  return (
    <div id={styles.termsAndConditions}>
      <div className={'gb-contentblock level-2 gb-markdown'}>
        <div className={'legal-texts'}>
          <GlamstarChallengeTerms.react />
        </div>
      </div>
    </div>
  );
}
